<template>
  <StoryPage
    :story="story"
    :other-stories="otherStories"
  />
</template>

<script setup>
const { $cmsApi } = useNuxtApp();
const route = useRoute();
const config = useRuntimeConfig();

const { data, error } = await useAsyncData(async () => {
  const { memberStory, otherMemberStories } = await $cmsApi.get(
    `/member-story-with-related/${route.params.slug}`
  );

  return {
    story: memberStory,
    otherStories: otherMemberStories,
  };
});

if (error.value) {
  const errorData =
    error.value?.statusCode === 410
      ? { statusCode: 410, message: 'Page Gone' }
      : { statusCode: 404, message: 'Page not found' };
  throw createError(errorData);
}

const story = data.value?.story || {};
const otherStories = data.value?.otherStories || [];

useHead({
  title: story.title,
  meta: [
    {
      key: 'og:title',
      property: 'og:title',
      content: story.title,
    },
    {
      key: 'og:description',
      name: 'description',
      property: 'og:description',
      content: story.summary,
    },
    {
      key: 'og:url',
      property: 'og:url',
      content: config.public.hostUrl + route.path,
    },
    {
      key: 'og:image',
      property: 'og:image',
      content: story.image,
    },
    {
      key: 'og:type',
      property: 'og:type',
      content: 'article',
    },
  ].filter((x) => x.content),
});
</script>
